import { render, staticRenderFns } from "./battalionHeader.vue?vue&type=template&id=258081ee&scoped=true"
import script from "./battalionHeader.vue?vue&type=script&lang=js"
export * from "./battalionHeader.vue?vue&type=script&lang=js"
import style0 from "./battalionHeader.vue?vue&type=style&index=0&id=258081ee&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "258081ee",
  null
  
)

export default component.exports